import axios from "axios";
import { API_BASE_URL, API_PASS, API_URL_GATEWAY, API_USER, CLIENT_ID, CLIENT_SECRET } from "../config/env";

import { getAuth, clearAuth } from "./authStorage";
import { refresh } from "./AuthService";
import { isJwtExpired } from "./jwt";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 100000,
});

// Ajusta esto si apiClient también llama al gateway OAuth (idealmente no)
const isOAuthRequest = (config) => {
  const url = config?.url ?? "";
  return url.includes("/oauth") || url.includes("/token");
};

let refreshPromise = null;

const doRefreshOnce = async () => {
  if (!refreshPromise) {
    refreshPromise = refresh().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

apiClient.interceptors.request.use(async (config) => {
  const auth = getAuth();
  const access = auth?.access_token;

  // Si hay token y está expirado, refresca antes del request
  if (access && isJwtExpired(access) && !isOAuthRequest(config)) {
    try {
      await doRefreshOnce();
    } catch (e) {
      clearAuth();
      window.location.assign("/portal-web/"+window.idTransaction);
      throw e;
    }
  }

  const freshAuth = getAuth();
  if (freshAuth?.access_token) {
    config.headers.Authorization = `Bearer ${freshAuth.access_token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => {
        const data = response?.data;

       //si es string, devolverlo tal cual
        if (typeof data === "string") {
            return data;
        }

        if (data && typeof data === "object" && "object" in data) {
            return data.object;
        }

        return data ?? {};
    },
  async (error) => {
    const response = error?.response;
    const originalRequest = error?.config;

    if (!response) return Promise.reject(error);

    const debug = (response?.data?.debugMessage ?? "").toLowerCase();
    const isUnauthorized =
      response.status === 401 ||
      debug.includes("unauthorized") ||
      debug.includes("401");

    if (!isUnauthorized) return Promise.reject(error);

    // evita bucles
    if (originalRequest?._retry || isOAuthRequest(originalRequest)) {
      clearAuth();
      window.location.assign("/portal-web/"+window.idTransaction);
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      const newAuth = await doRefreshOnce();
      originalRequest.headers.Authorization = `Bearer ${newAuth.access_token}`;
      return apiClient(originalRequest);
    } catch (e) {
      clearAuth();
      window.location.assign("/portal-web/"+window.idTransaction);
      return Promise.reject(e);
    }
  }
);

export default apiClient;